import { gql } from "@apollo/client";

export const GET_USERS = gql`
  query GetUsers {
    users {
      id
      email
      name
      googleId
      googleEmail
      googlePicture
      provider
      pushbulletKey
      phoneNumber
      telegramId
      notificationPreferences
      defaultTradeFee
      defaultPositionFee
      feeCurrency
      createdAt
      updatedAt
    }
  }
`;

export const GET_ME = gql`
  query Me {
    me {
      id
      email
      name
      googleId
      googleEmail
      googlePicture
      provider
      pushbulletKey
      phoneNumber
      telegramId
      notificationPreferences
      defaultTradeFee
      defaultPositionFee
      feeCurrency
      createdAt
      updatedAt
    }
  }
`;

export const CREATE_USER = gql`
  mutation CreateUser($input: CreateUserInput!) {
    createUser(createUserInput: $input) {
      id
      email
      name
      googleId
      googleEmail
      googlePicture
      provider
      pushbulletKey
      phoneNumber
      telegramId
      notificationPreferences
      createdAt
      updatedAt
    }
  }
`;

export const UPDATE_USER = gql`
  mutation UpdateUser($id: String!, $data: UpdateUserInput!) {
    updateUser(id: $id, data: $data) {
      id
      email
      name
      googleId
      googleEmail
      googlePicture
      provider
      pushbulletKey
      phoneNumber
      telegramId
      notificationPreferences
      defaultTradeFee
      defaultPositionFee
      feeCurrency
      createdAt
      updatedAt
    }
  }
`;

export const UPDATE_USER_FEE_SETTINGS = gql`
  mutation UpdateUserFeeSettings($feeSettings: UpdateUserFeeSettingsInput!) {
    updateUserFeeSettings(feeSettings: $feeSettings) {
      id
      defaultTradeFee
      defaultPositionFee
      feeCurrency
    }
  }
`;

export const DELETE_USER = gql`
  mutation DeleteUser($id: String!) {
    removeUser(id: $id) {
      id
    }
  }
`;
